import React, { useEffect, useState } from 'react';
import '../../../styles/components/MyMonthlyEarning/MyMonthlyEarning.scss';
import useMoengage from '../../../hooks/useMoengage';
import Slider from '@mui/material/Slider';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


function MyMonthlyEarning(props) {
    const trackEvent = useMoengage()[1];
   
    const { baseSalary, companyName} = props;
    const salary = parseInt((baseSalary.substring(1).split('.')[0]).replace( /,/g, "" ));
    const [maxMontlyEarning, setmaxMonthlyEarning] = useState(salary);
    const [maxWeeklyEarning, setmaxWeeklyEarning] = useState(salary);
    const [maxWorkingDays, setMaxWorkingDays] = useState(6);
    const [maxWorkingHours, setMaxWorkingHours] = useState(10);
    
    useEffect(() => {
      const weeklyEarning = maxWorkingHours*maxWorkingDays*(salary/(240));
      const margin = weeklyEarning * 0.1;
      const projectedEarningWeekly = weeklyEarning+margin;
      const projectedEarningMonthly = (weeklyEarning+margin)*4;
      trackEvent('earnings_calculated_tried', {
        company: {companyName},
        average_earning: {salary},
        projected_earnings_weekly: {projectedEarningWeekly},
        projected_earnings_monthly: {projectedEarningMonthly}
  
      });
      setmaxWeeklyEarning(weeklyEarning+margin);
      setmaxMonthlyEarning((weeklyEarning+margin)*4);
    },[maxWorkingDays, maxWorkingHours])
    
    const sliderValueChanged1 = (val => {
      setMaxWorkingDays(val);
    });
    const sliderValueChanged2 = (val => {
      setMaxWorkingHours(val);
    });
  
    return (
        <div className = "Earning_calculator" >
          <Accordion style = {{backgroundColor: '#F2F2F2'}} onChange ={() => {
                trackEvent('earnings_calculator_viewed', {
                  company: {companyName}
                });}} >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography >
                <span>
                  <strong>Calculate Monthly Income?</strong><br/>Based on your working Hours
                </span>
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                <div className = "calculator">
                <div className = "income-section">
                  <div className = "salary">
                  <div className = "monthly">
                  <span>₹ Monthly Income </span>
                    <p>Upto ₹{maxMontlyEarning}</p>
                  </div>
                  <div class="vl"></div>
                  <div  className ="weekly">
                  <span>₹ Weekly Income </span>
                    <p>Upto ₹{maxWeeklyEarning}</p>
                  </div>
                  </div>
                    
                </div>
                <br/>
                <div className="calculate-earn">
                  <p><span>How many days</span> in a week<br/> will you be working?</p>
                  <div>
                    <p><span>{maxWorkingDays}</span>  &nbsp;  Days</p><hr/> 
                  </div>
                </div>
                  <Slider className = "slider"
                      defaultValue={6}
                      getAriaValueText={sliderValueChanged1}
                      sx={{
                        width: 300
                      }}
                      step={1}
                      min={0}
                      max={6}
                  />
                <div className="calculate-earn">
                  <p><span>How many hours</span> in a day<br/> will you be working?</p>
                  <div>
                    <p><span>{maxWorkingHours}</span> Hours</p><hr/> 
                  </div>
                </div>
                  <Slider className = "slider"
                      defaultValue={10}
                      getAriaValueText={sliderValueChanged2}
                      sx={{
                        width: 300
                      }}
                      step={1}
                      min={0}
                      max={10}
                  />
                  </div>
              </Typography>
            </AccordionDetails>
          </Accordion>
        </div>
    );
  }
  export default MyMonthlyEarning;
  